module.exports = __webpack_public_path__ + "static/media/A-open.0e813759.svg";